import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@teorema/patron';
import { FilterField, FilterOperator, Ticket } from 'src/app/models';
import { TcDataService, TcTicketService } from 'src/app/shared/services';
import { AbstractTicketComponent } from '../abstract-ticket/abstract-ticket.component';
import { TicketShowBodyComponent } from '../ticket-show/ticket-show-body/ticket-show-body.component';

@Component({
  selector: 'app-edit-ticket',
  templateUrl: './edit-ticket.component.html',
  styles: [],
  standalone: false,
})
export class EditTicketComponent extends AbstractTicketComponent implements OnInit {
  id?: string;
  loadingTicket: boolean = false;
  @ViewChild(TicketShowBodyComponent)
  ticketShowBodyComponent?: TicketShowBodyComponent;

  constructor(
    protected override dataService: TcDataService,
    protected override _location: Location,
    protected override router: Router,
    protected tcTicketService: TcTicketService,
    protected route: ActivatedRoute,
    protected toastService: ToastService,
    private titleService: Title
  ) {
    super(dataService, _location, router);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.tcTicketService.getFiltersFromLocalStorage();
    this.loadTicket();
  }

  override assembleTicket(response: Ticket) {
    var usersArray: string[] = [];
    if (response.hasOwnProperty('data')) {
      this.entity = response['data'][0];
    } else {
      this.entity = response;
    }

    if (this.entity!.details) {
      var detailsArray = this.entity!.details;
      detailsArray.sort((a, b) => (a.created_at! < b.created_at! ? 1 : -1));
      detailsArray = detailsArray.filter(det => {
        return det.observation && det.observation.length;
      });

      detailsArray.forEach(function (detail) {
        if (detail.user && usersArray.indexOf(detail.user!.id) == -1) {
          usersArray.push(detail.user!.id);
        }
      });

      this.entity!.details = detailsArray;
    }

    // setTimeout(() => {
    this.ticketShowBodyComponent!.assembleTicket(this.entity!);
    this.ticketShowBodyComponent!.setUserValues();
    this.loadingTicket = false;

    if (this.entity?.ticket_number_teorema) {
      this.titleService.setTitle(this.entity.ticket_number_teorema);
    }
    // }, 1);
  }

  loadTicket() {
    this.loadingTicket = true;
    this.route.params.subscribe(async params => {
      if (params['id']) {
        this.id = params['id'];
      }
      if (!this.id) {
        this.router.navigate(['/chamados/novo-chamado']);
        return;
      }

      let promisse: any = null;
      let isNumber: boolean = this.id!!.length <= 10;
      if (!isNumber) {
        promisse = this.tcTicketService.findById(this.id!!);
      } else {
        promisse = this.tcTicketService.findAll({
          perPage: 1,
          filters: [
            new FilterField({
              name: 'ticket_number_teorema',
              value: this.id,
              operator: FilterOperator.equal,
              label: '',
            }),
          ],
        });
      }

      let response = await promisse.catch(e => {
        console.error(e);
        this.toastService.show({
          color: 'error',
          message: 'Houve um erro ao carregar os dados',
        });
      });

      if (this.checkIfTicketExists(response, isNumber)) {
        this.assembleTicket(response);
      } else {
        this.loadingTicket = false;
      }
    });
  }

  checkIfTicketExists(response, isNumber) {
    if (response && (!isNumber || response.data?.length)) {
      return true;
    } else {
      this.toastService.show({
        color: 'error',
        message: 'Ticket ' + this.id + ' não encontrado',
      });
      this.router.navigate(['/chamados/novo-chamado']);
      return false;
    }
  }
}
